const DEFAULT_STROKE_COLOR = {
    type: 'custom',
    value: 'rgba(0, 0, 0, 0)'
};

module.exports = { DEFAULT_STROKE_COLOR };
